import axios from "axios";
import config from "../../../config";
export interface Tenant {
  id: number;
  esKey: string;
  zohoCustomerName?: string | null;
}
export interface TenantListFilter {
  limit: number;
  tenantId?: number | undefined;
  tenant?: string | undefined;
}
const { apiServerUrl } = config;

export const getAccessibleTenantList = async (
  filters: TenantListFilter
): Promise<Tenant[]> => {
  try {
    const response = await axios.post<Tenant[]>(
      `${apiServerUrl}/users/tenant/list`,
      filters
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Failed to fetch tenant list"
      );
    }
    throw error;
  }
};

export const updateTenant = async (tenantId: number) => {
  try {
    const response = await axios.put(`${apiServerUrl}/users/tenant/access`, {
      tenantId,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Failed to fetch tenant list"
      );
    }
    throw error;
  }
};

// Tenant-free — reaches the api-server even when `auth` itself would fail to resolve a tenant
// (no accessible tenant, or the last-used one is now deactivated). See
// api-server/src/middlewares/auth-internal-user.ts. Only ever shown to an internal user stuck at
// a restriction screen, so it is deliberately separate from getAccessibleTenantList/updateTenant
// above, which both require `auth` to have already succeeded.
export const getInternalTenantList = async (
  filters: TenantListFilter
): Promise<Tenant[]> => {
  try {
    const response = await axios.post<Tenant[]>(
      `${apiServerUrl}/internal/tenants/list`,
      filters
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Failed to fetch tenant list"
      );
    }
    throw error;
  }
};

export const switchInternalTenant = async (tenantId: number) => {
  try {
    const response = await axios.put(`${apiServerUrl}/internal/tenants/access`, {
      tenantId,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Failed to switch tenant"
      );
    }
    throw error;
  }
};
